// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ec5a0896","667":"1faf4e21","977":"c761b6b7"}[chunkId] + ".chunk.js";
};